// extracted by mini-css-extract-plugin
export default {"select":"Select_select__9JSkP","error":"Select_error__s55D+"};